var $846290b758c9a63c$exports = {};
const $846290b758c9a63c$var$startBtn = document.querySelector(".buttonParallax");
const $846290b758c9a63c$var$projectInfo = document.querySelector(".section-to-scroll");
//parallax when button was pressed
$846290b758c9a63c$var$startBtn.addEventListener("click", ()=>{
    if ($846290b758c9a63c$var$projectInfo.classList.contains("s-project__info")) document.documentElement.scrollTo(0, $846290b758c9a63c$var$projectInfo.offsetTop + 100, 2000);
    else document.documentElement.scrollTo(0, $846290b758c9a63c$var$projectInfo.offsetTop, 2000);
});


//# sourceMappingURL=hp.671672d5.js.map
